module.exports = __webpack_public_path__ + "img/4_1.7cdf6c51.jpg";